import PropTypes from 'prop-types';
import Creatives from '../../components/reusables/Creatives';
import { CopyValueWidget } from '../../components/reusables';
import messages from '../../i18n/base-en';
import { useRef } from 'react';
import { useSlider } from './SliderContext.react';
import LinkSettings from './LinkSettings';
import { Gtm } from '../../utils/gtm';
import Skeleton from '../../components/reusables/Skeleton/Skeleton';

const SmartLinkAdTool = ({
  affId,
  buttonRef,
  creatives,
  creativesIsFetching,
  creativesSearchForm,
  creativesSizes,
  creativesSizesIsFetching,
  dispatch,
  fields,
  formChangedHandler,
  getBackOffers,
  isCurrentlySelectedCamSmartLink,
  isCurrentlySelectedDatingSmartLink,
  isOpen,
  location,
  offerOverlay,
  offerPopCode,
  offerPopUpCode,
  offersCreativesViewMode,
  offerTrackingLinkIsFetching,
  onSmartlinkCopy,
  setIsOpen,
  trackingLink,
  userEmail,
  values,
  windowWidthSize,
}) => {
  const { previousSlide, showSliderCreative } = useSlider();
  const linkSettingsButtonRef = useRef(null);
  const isSmartlinkDatingOrCam =
    isCurrentlySelectedCamSmartLink(values.offer_id) || isCurrentlySelectedDatingSmartLink(values.offer_id);

  const tabs = {
    iframe: {
      eventLabel: 'Console-Smartlink-IFrame-Tab',
      show: true,
    },
    banner: {
      eventLabel: 'Console-Smartlink-Banner-Tab',
      show: true,
    },
    content: {
      eventLabel: 'Console-Smartlink-Content-Tab',
      show: false,
    },
    email: {
      eventLabel: 'Console-Smartlink-Email-Tab',
      show: false,
    },
    html: {
      eventLabel: 'Console-Smartlink-HTML-Tab',
      show: true,
    },
    link: {
      eventLabel: 'Console-Smartlink-Link-Tab',
      show: false,
    },
    overlay: {
      eventLabel: 'Console-Smartlink-Overlay-Tab',
      show: false,
    },
    pop: {
      eventLabel: 'Console-Smartlink-Pop-Tab',
      show: true,
    },
    chatHead: {
      eventLabel: 'Console-Smartlink-ChatHead-Tab',
      show: isSmartlinkDatingOrCam,
    },
  };

  const backOffers = getBackOffers(values.offer_id);
  const hasPopUnder = trackingLink ? new URL(trackingLink).searchParams.has('po') : false;
  return (
    <div className="smart-link-container adtool-container">
      <span className="back-btn" onClick={() => previousSlide()}>
        <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.05 3.951L7.00005 9.975L13.05 16"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </svg>
        Back
      </span>
      <div className="header-container">
        <div className="header-adtool-smartlink-container">
          <div className="header-box">
            <h2 className="primary-color">Share Your Link</h2>
            <span
              className={`link-settings-button ${isOpen ? 'open' : ''}`}
              onClick={() => {
                if (!isOpen) {
                  Gtm.newEvent('smartlink_step3', false, 'click', 'string', 'change_settings');
                }
                setIsOpen(!isOpen);
              }}
              ref={windowWidthSize <= 576 ? buttonRef : linkSettingsButtonRef}
            >
              <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_183_4865)">
                  <path
                    d="M7.03912 4.27777C5.52245 4.27777 4.31689 5.48333 4.31689 6.99999C4.31689 8.51666 5.52245 9.72222 7.03912 9.72222C8.55578 9.72222 9.76134 8.51666 9.76134 6.99999C9.76134 5.48333 8.55578 4.27777 7.03912 4.27777ZM7.03912 8.94444C5.95023 8.94444 5.09467 8.08888 5.09467 6.99999C5.09467 5.9111 5.95023 5.05555 7.03912 5.05555C8.12801 5.05555 8.98356 5.9111 8.98356 6.99999C8.98356 8.08888 8.12801 8.94444 7.03912 8.94444Z"
                    fill="#00BD00"
                  />
                  <path
                    d="M12.7556 5.71666L11.6667 5.36666L11.4334 4.78333L11.9778 3.77222C12.0945 3.53888 12.0556 3.22777 11.8612 3.03333L10.9278 2.09999C10.7334 1.90555 10.4223 1.86666 10.1889 1.98333L9.17783 2.52777L8.5945 2.29444L8.2445 1.20555C8.16672 0.972215 7.93339 0.777771 7.66117 0.777771H6.33894C6.06672 0.777771 5.83339 0.972215 5.7945 1.24444L5.4445 2.33333C5.21117 2.37222 5.01672 2.44999 4.82228 2.56666L3.81117 2.02222C3.57783 1.90555 3.26672 1.94444 3.07228 2.13888L2.13894 3.07222C1.9445 3.26666 1.90561 3.57777 2.02228 3.8111L2.52783 4.78333C2.45005 4.97777 2.37228 5.2111 2.2945 5.40555L1.20561 5.75555C0.972276 5.83333 0.777832 6.06666 0.777832 6.33888V7.6611C0.777832 7.93333 0.972277 8.16666 1.2445 8.24444L2.33339 8.59444L2.56672 9.17777L2.02228 10.1889C1.90561 10.4222 1.9445 10.7333 2.13894 10.9278L3.07228 11.8611C3.26672 12.0555 3.57783 12.0944 3.81117 11.9778L4.82228 11.4333L5.40561 11.6667L5.75561 12.7944C5.83339 13.0278 6.06672 13.2222 6.33894 13.2222H7.66117C7.93339 13.2222 8.16672 13.0278 8.2445 12.7944L8.5945 11.6667L9.17783 11.4333L10.1889 11.9778C10.4223 12.0944 10.7334 12.0555 10.9278 11.8611L11.8612 10.9278C12.0556 10.7333 12.0945 10.4222 11.9778 10.1889L11.4334 9.17777L11.6667 8.59444L12.7945 8.24444C13.0278 8.16666 13.2223 7.93333 13.2223 7.6611V6.33888C13.2223 6.06666 13.0278 5.79444 12.7556 5.71666ZM12.4445 7.54444L11.0445 7.97222L11.0056 8.16666L10.6556 8.98333L10.5389 9.17777L11.2389 10.4611L10.4612 11.2389L9.17783 10.5389L8.98339 10.6555C8.71117 10.8111 8.43894 10.9278 8.16672 11.0055L7.97228 11.0444L7.5445 12.4444H6.45561L6.02783 11.0444L5.83339 11.0055L5.01672 10.6555L4.82228 10.5389L3.53894 11.2389L2.76117 10.4611L3.46117 9.17777L3.3445 8.98333C3.18894 8.7111 3.07228 8.43888 2.9945 8.16666L2.95561 7.97222L1.55561 7.54444V6.45555L2.87783 6.06666L2.95561 5.87222C3.03339 5.5611 3.15005 5.28888 3.30561 5.01666L3.42228 4.82222L2.76117 3.53888L3.53894 2.7611L4.78339 3.4611L4.97783 3.34444C5.25005 3.18888 5.52228 3.07222 5.83339 2.99444L6.02783 2.91666L6.45561 1.55555H7.5445L7.97228 2.91666L8.16672 2.99444C8.43894 3.07222 8.71117 3.18888 8.98339 3.34444L9.17783 3.4611L10.4612 2.7611L11.2389 3.53888L10.5389 4.82222L10.6556 5.01666C10.8112 5.28888 10.9278 5.5611 11.0056 5.83333L11.0445 6.02777L12.4445 6.45555V7.54444Z"
                    fill="#00BD00"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_183_4865">
                    <rect fill="white" height="14" width="14" />
                  </clipPath>
                </defs>
              </svg>
              {windowWidthSize >= 992 && 'Link settings'}
            </span>
          </div>
          {windowWidthSize >= 576 && (
            <LinkSettings
              backOffers={backOffers}
              fields={fields}
              formChangedHandler={formChangedHandler}
              hasPopUnder={hasPopUnder}
              isOpen={isOpen}
              linkSettingsButtonRef={linkSettingsButtonRef}
              setIsOpen={setIsOpen}
            />
          )}
        </div>
        <div className="link-container">
          <div className="creatives-tracking-link">
            {offerTrackingLinkIsFetching ? (
              <Skeleton height="55px" width="100%" />
            ) : (
              <CopyValueWidget
                dispatch={dispatch}
                icon={
                  <svg fill="none" height="14" viewBox="0 0 15 14" width="15" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_32_6704)">
                      <path
                        d="M8.30134 10.5312L5.91756 11.9075C5.15776 12.3462 4.35571 12.4524 3.51141 12.2262C2.6671 11.9999 2.02526 11.5068 1.58589 10.7468C1.14651 9.98686 1.04039 9.18445 1.26752 8.33963C1.49465 7.49481 1.98753 6.8531 2.74617 6.4145L5.12995 5.03822L5.51884 5.7118L3.13506 7.08807C2.56476 7.41733 2.19405 7.90199 2.02293 8.54204C1.85162 9.1828 1.93046 9.78811 2.25946 10.358C2.58846 10.9278 3.07312 11.2985 3.71343 11.4701C4.35374 11.6416 4.95882 11.5629 5.52867 11.2339L7.91245 9.85765L8.30134 10.5312ZM5.485 8.94474L5.09611 8.27116L9.81113 5.54894L10.2 6.22252L5.485 8.94474ZM10.1665 9.45439L9.77758 8.78082L12.1607 7.40493C12.731 7.07567 13.1017 6.59102 13.2728 5.95096C13.4444 5.31065 13.3657 4.70557 13.0367 4.13573C12.7077 3.56588 12.223 3.19518 11.5827 3.02361C10.9424 2.85203 10.3373 2.93075 9.76747 3.25975L7.38436 4.63564L6.99547 3.96206L9.37858 2.58617C10.1384 2.14751 10.9406 2.04116 11.7854 2.26713C12.6302 2.4931 13.2718 2.98634 13.7102 3.74684C14.1487 4.50734 14.2548 5.30975 14.0286 6.15405C13.8024 6.99835 13.3095 7.64006 12.55 8.07918L10.1665 9.45439Z"
                        fill="#F8F8F8"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_32_6704">
                        <rect fill="white" height="14" transform="translate(0.5)" width="14" />
                      </clipPath>
                    </defs>
                  </svg>
                }
                id="smart-link-trackinglink"
                isSmartlink
                label={messages.smartLinkYourLink}
                onCopy={onSmartlinkCopy}
                value={trackingLink}
              />
            )}
          </div>
        </div>
      </div>
      <div className="separator header-container">
        <p>or</p>
      </div>
      <div className="row header-container promotools">
        <div className="header-box">
          <h2>Use Our Promo Tools</h2>
        </div>
      </div>
      <div id="smart-link-adtool">
        {showSliderCreative ? (
          <Creatives
            affId={affId}
            creatives={creatives}
            creativesIsFetching={creativesIsFetching}
            creativesSearchForm={creativesSearchForm}
            creativesSizes={creativesSizes}
            creativesSizesIsFetching={creativesSizesIsFetching}
            defaultTab="trending"
            dispatch={dispatch}
            displaySubHeaders
            isSmartlink
            isSmartlinkDatingOrCam={isSmartlinkDatingOrCam}
            location={location}
            offerId={values.offer_id}
            offerOverlay={offerOverlay}
            offerPopCode={offerPopCode}
            offerPopUpCode={offerPopUpCode}
            offersCreativesViewMode={offersCreativesViewMode}
            onSmartlinkCopy={onSmartlinkCopy}
            tabs={tabs}
            trackingLink={trackingLink}
            userEmail={userEmail}
            values={values}
          />
        ) : null}
      </div>
    </div>
  );
};

SmartLinkAdTool.propTypes = {
  affId: PropTypes.string.isRequired,
  buttonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
  creatives: PropTypes.object.isRequired,
  creativesIsFetching: PropTypes.bool.isRequired,
  creativesSearchForm: PropTypes.object.isRequired,
  creativesSizes: PropTypes.array.isRequired,
  creativesSizesIsFetching: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  formChangedHandler: PropTypes.func.isRequired,
  getBackOffers: PropTypes.func.isRequired,
  isCurrentlySelectedCamSmartLink: PropTypes.func.isRequired,
  isCurrentlySelectedDatingSmartLink: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  offerOverlay: PropTypes.any,
  offerPopCode: PropTypes.any,
  offerPopUpCode: PropTypes.any,
  offerTrackingLinkIsFetching: PropTypes.bool,
  offersCreativesViewMode: PropTypes.string.isRequired,
  onSmartlinkCopy: PropTypes.func,
  setIsOpen: PropTypes.func.isRequired,
  trackingLink: PropTypes.string,
  userEmail: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  windowWidthSize: PropTypes.number.isRequired,
};

export default SmartLinkAdTool;
